(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-filter-preview"] && !Shopify.designMode) return;
  try {
    
  class SapiatoCollectionLoader {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-sapiato-product-grid]');
      this.status = root.querySelector('[data-sapiato-status]');
      this.statusText = root.querySelector('[data-sapiato-status-text]');
      this.sentinel = root.querySelector('[data-sapiato-sentinel]');
      this.autoScroll = root.dataset.autoScroll === 'true';
      this.loading = false;
      this.observer = null;

      root.classList.add('is-enhanced');
      this.bindViewControls();
      this.bindProductCarousels();
      this.bindQuickAdd();
      this.bindImpressions();
      this.playInitialCarouselHint();

      if (this.autoScroll) {
        this.bindAutoScroll();
      }
    }

    get nextLink() {
      return this.root.querySelector('[data-sapiato-next-link]');
    }

    get productCards() {
      return Array.from(this.grid.querySelectorAll('[data-sapiato-product-card]'));
    }

    bindViewControls() {
      this.root.querySelectorAll('[data-sapiato-view]').forEach((button) => {
        button.addEventListener('click', () => {
          this.root.dataset.view = button.dataset.sapiatoView;
          this.root.querySelectorAll('[data-sapiato-view]').forEach((viewButton) => {
            viewButton.setAttribute('aria-pressed', String(viewButton === button));
          });
        });
      });

      this.root.querySelectorAll('[data-sapiato-mobile-view]').forEach((button) => {
        button.addEventListener('click', () => {
          this.root.dataset.mobileView = button.dataset.sapiatoMobileView;
          this.root.querySelectorAll('[data-sapiato-mobile-view]').forEach((viewButton) => {
            viewButton.setAttribute('aria-pressed', String(viewButton === button));
          });
        });
      });
    }

    bindProductCarousels() {
      this.root.querySelectorAll('[data-sapiato-product-carousel]').forEach((carousel) => {
        if (carousel.dataset.sapiatoCarouselEnhanced === 'true') {
          return;
        }

        carousel.dataset.sapiatoCarouselEnhanced = 'true';
        let startX = 0;
        let startY = 0;
        let tracking = false;
        let moved = false;

        const reset = () => {
          startX = 0;
          startY = 0;
          tracking = false;
          moved = false;
        };

        carousel.addEventListener('pointerdown', (event) => {
          carousel.dataset.sapiatoUserInteracted = 'true';

          if (event.pointerType === 'mouse') {
            return;
          }

          startX = event.clientX;
          startY = event.clientY;
          tracking = true;
          moved = false;
        }, { passive: true });

        carousel.addEventListener('pointermove', (event) => {
          if (!tracking) {
            return;
          }

          const deltaX = Math.abs(event.clientX - startX);
          const deltaY = Math.abs(event.clientY - startY);
          if (deltaX > 10 && deltaX > deltaY) {
            moved = true;
          }
        }, { passive: true });

        carousel.addEventListener('pointerup', () => {
          if (moved) {
            carousel.dataset.sapiatoSuppressClick = 'true';
            window.setTimeout(() => {
              delete carousel.dataset.sapiatoSuppressClick;
            }, 400);
          }

          reset();
        }, { passive: true });

        carousel.addEventListener('pointercancel', reset, { passive: true });

        carousel.addEventListener('click', (event) => {
          if (carousel.dataset.sapiatoSuppressClick !== 'true') {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          delete carousel.dataset.sapiatoSuppressClick;
        }, true);
      });
    }

    bindQuickAdd() {
      this.root.querySelectorAll('[data-sapiato-quick-add]').forEach((form) => {
        if (form.dataset.sapiatoQuickAddEnhanced === 'true') {
          return;
        }

        form.dataset.sapiatoQuickAddEnhanced = 'true';

        const select = form.querySelector('[data-sapiato-variant-select]');
        const submit = form.querySelector('[data-sapiato-quick-add-submit]');
        const toggle = form.querySelector('[data-sapiato-quick-add-toggle]');
        const panel = form.querySelector('[data-sapiato-quick-add-panel]');
        const feedback = form.querySelector('[data-sapiato-quick-add-feedback]');
        const picker = form.querySelector('[data-sapiato-variant-picker]');
        const pickerToggle = form.querySelector('[data-sapiato-variant-picker-toggle]');
        const pickerOptions = form.querySelector('[data-sapiato-variant-picker-options]');
        const pickerLabel = form.querySelector('[data-sapiato-variant-picker-label]');

        const setFeedback = (message) => {
          if (!feedback) {
            return;
          }

          feedback.textContent = message;
        };

        const updateSubmitState = () => {
          if (!select || !submit) {
            return;
          }

          submit.disabled = !select.value;
        };

        const closePicker = () => {
          if (pickerToggle) {
            pickerToggle.setAttribute('aria-expanded', 'false');
          }
          if (pickerOptions) {
            pickerOptions.hidden = true;
          }
        };

        const openPicker = () => {
          if (!pickerToggle || !pickerOptions) {
            return;
          }

          this.root.querySelectorAll('[data-sapiato-variant-picker-options]').forEach((openOptions) => {
            if (openOptions === pickerOptions || openOptions.hidden) {
              return;
            }

            const openPicker = openOptions.closest('[data-sapiato-variant-picker]');
            const openToggle = openPicker ? openPicker.querySelector('[data-sapiato-variant-picker-toggle]') : null;
            openOptions.hidden = true;
            if (openToggle) {
              openToggle.setAttribute('aria-expanded', 'false');
            }
          });

          pickerToggle.setAttribute('aria-expanded', 'true');
          pickerOptions.hidden = false;
        };

        const choosePickerOption = (option) => {
          if (!select || option.getAttribute('aria-disabled') === 'true') {
            return;
          }

          select.value = option.dataset.variantId || '';
          if (pickerLabel) {
            pickerLabel.textContent = option.dataset.optionLabel || option.textContent.trim();
          }
          if (pickerOptions) {
            pickerOptions.querySelectorAll('[data-sapiato-variant-picker-option]').forEach((button) => {
              button.setAttribute('aria-selected', String(button === option));
            });
          }
          updateSubmitState();
          closePicker();
          if (submit) {
            submit.focus({ preventScroll: true });
          }
        };

        const closePanel = () => {
          form.classList.remove('is-open');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          }
          if (panel) {
            panel.hidden = true;
          }
        };

        const openPanel = () => {
          this.root.querySelectorAll('[data-sapiato-quick-add].is-open').forEach((openForm) => {
            if (openForm === form) {
              return;
            }

            const openToggle = openForm.querySelector('[data-sapiato-quick-add-toggle]');
            const openPanel = openForm.querySelector('[data-sapiato-quick-add-panel]');
            openForm.classList.remove('is-open');
            if (openToggle) {
              openToggle.setAttribute('aria-expanded', 'false');
            }
            if (openPanel) {
              openPanel.hidden = true;
            }
          });

          form.classList.add('is-open');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          }
          if (panel) {
            panel.hidden = false;
            const firstSize = panel.querySelector('button:not(:disabled)');
            if (firstSize) {
              firstSize.focus({ preventScroll: true });
            }
          }
        };

        if (select) {
          updateSubmitState();
          select.addEventListener('change', updateSubmitState);
        }

        if (pickerToggle && pickerOptions) {
          pickerToggle.addEventListener('click', () => {
            if (pickerOptions.hidden) {
              openPicker();
            } else {
              closePicker();
            }
          });

          pickerOptions.querySelectorAll('[data-sapiato-variant-picker-option]').forEach((option) => {
            option.addEventListener('click', () => choosePickerOption(option));
          });

          document.addEventListener('click', (event) => {
            if (!picker || picker.contains(event.target)) {
              return;
            }

            closePicker();
          }, { passive: true });
        }

        if (toggle && panel) {
          toggle.addEventListener('click', () => {
            if (form.classList.contains('is-open')) {
              closePanel();
            } else {
              openPanel();
            }
          });

          document.addEventListener('click', (event) => {
            if (!form.classList.contains('is-open') || form.contains(event.target)) {
              return;
            }

            closePanel();
          }, { passive: true });
        }

        form.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closePanel();
            closePicker();
          }
        });

        form.addEventListener('focusout', (event) => {
          if (!picker || !pickerOptions || pickerOptions.hidden || picker.contains(event.relatedTarget)) {
            return;
          }

          closePicker();
        });

        form.addEventListener('focusout', (event) => {
          if (!panel || !form.classList.contains('is-open') || form.contains(event.relatedTarget)) {
            return;
          }

          closePanel();
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          const submitter = event.submitter;
          const formData = new FormData(form);
          const variantId = submitter && submitter.name === 'id' ? submitter.value : formData.get('id');

          if (!variantId) {
            setFeedback(form.dataset.chooseSizeError || '');
            if (pickerToggle) {
              pickerToggle.focus();
            } else if (select) {
              select.focus();
            }
            return;
          }

          const quantity = Number(formData.get('quantity') || 1);
          const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
          const labelButton = submitter && submitter.matches('[data-sapiato-quick-add-submit]') ? submitter : null;
          const originalLabel = labelButton ? labelButton.textContent : '';

          buttons.forEach((button) => {
            button.dataset.sapiatoWasDisabled = String(button.disabled);
            button.disabled = true;
          });

          if (select) {
            select.disabled = true;
          }

          if (labelButton) {
            labelButton.textContent = form.dataset.addingText || originalLabel;
          }
          setFeedback(form.dataset.addingText || '');

          try {
            const response = await fetch(form.dataset.sapiatoCartAddUrl || `${form.action}.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: variantId,
                quantity
              })
            });

            if (!response.ok) {
              throw new Error(form.dataset.errorText || '');
            }

            const item = await response.json();
            if (labelButton) {
              labelButton.textContent = form.dataset.addedText || originalLabel;
            }
            setFeedback(form.dataset.addedText || '');

            window.dispatchEvent(new CustomEvent('sapiato:quick-add', {
              detail: {
                item,
                productId: form.dataset.productId,
                variantId
              }
            }));

            window.setTimeout(() => {
              closePanel();
              closePicker();
              setFeedback('');
              if (labelButton) {
                labelButton.textContent = originalLabel;
              }
            }, 1200);
          } catch (error) {
            if (labelButton) {
              labelButton.textContent = originalLabel;
            }
            setFeedback(form.dataset.errorText || '');
          } finally {
            buttons.forEach((button) => {
              button.disabled = button.dataset.sapiatoWasDisabled === 'true';
              delete button.dataset.sapiatoWasDisabled;
            });

            if (select) {
              select.disabled = false;
            }

            updateSubmitState();
          }
        });
      });
    }

    playInitialCarouselHint() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const carousel = this.grid.querySelector('[data-sapiato-product-carousel]');
      if (!carousel || carousel.dataset.sapiatoHintPlayed === 'true') {
        return;
      }

      const slides = carousel.querySelectorAll('.sapiato-product-card__slide');
      if (slides.length < 2) {
        return;
      }

      carousel.dataset.sapiatoHintPlayed = 'true';

      const runHint = () => {
        if (!this.root.isConnected || carousel.dataset.sapiatoUserInteracted === 'true') {
          return;
        }

        const carouselWidth = carousel.clientWidth;
        if (!carouselWidth || carousel.scrollWidth <= carouselWidth) {
          return;
        }

        const hintDistance = Math.max(56, Math.min(carouselWidth * 0.36, 170));
        carousel.classList.add('is-swipe-hinting');
        carousel.scrollTo({ left: hintDistance, behavior: 'smooth' });

        window.setTimeout(() => {
          if (!this.root.isConnected || carousel.dataset.sapiatoUserInteracted === 'true') {
            return;
          }

          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        }, 520);

        window.setTimeout(() => {
          carousel.classList.remove('is-swipe-hinting');
        }, 1120);
      };

      const firstImage = carousel.querySelector('img');
      if (firstImage && !firstImage.complete) {
        firstImage.addEventListener('load', () => window.setTimeout(runHint, 420), { once: true });
        firstImage.addEventListener('error', () => window.setTimeout(runHint, 420), { once: true });
        return;
      }

      window.setTimeout(runHint, 620);
    }

    bindAutoScroll() {
      if (!this.sentinel || !this.nextLink) {
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadNextPage();
          }
        });
      }, { rootMargin: '700px 0px' });

      this.observer.observe(this.sentinel);
    }

    shouldAutoLoadAgain() {
      if (!this.autoScroll || !this.sentinel || !this.nextLink) {
        return false;
      }

      const rect = this.sentinel.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top <= viewportHeight + 700;
    }

    queueAutoLoadIfNeeded() {
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          if (!this.loading && this.shouldAutoLoadAgain()) {
            this.loadNextPage();
          }
        }, 80);
      });
    }

    bindImpressions() {
      if (!('IntersectionObserver' in window)) {
        return;
      }

      const impressionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const card = entry.target;
          if (card.dataset.sapiatoImpressionSent === 'true') {
            return;
          }

          card.dataset.sapiatoImpressionSent = 'true';
          window.dispatchEvent(new CustomEvent('sapiato:collection-product-impression', {
            detail: {
              productId: card.dataset.productId,
              productHandle: card.dataset.productHandle,
              collectionHandle: this.root.dataset.collectionHandle
            }
          }));
          impressionObserver.unobserve(card);
        });
      }, { threshold: 0.45 });

      this.productCards.forEach((card) => impressionObserver.observe(card));
      this.impressionObserver = impressionObserver;
    }

    async loadNextPage() {
      const link = this.nextLink;
      if (!link || this.loading) {
        return;
      }

      this.loading = true;
      this.setStatus('loading');
      let shouldCheckForContinuation = false;

      try {
        const visitedUrls = new Set();
        let nextHref = link.href;
        let incomingNextLink = null;
        let addedCards = [];

        while (nextHref && !addedCards.length && !visitedUrls.has(nextHref)) {
          visitedUrls.add(nextHref);
          const response = await fetch(nextHref, { credentials: 'same-origin' });
          if (!response.ok) {
            throw new Error('Could not load collection page');
          }

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const incomingRoot = documentFragment.querySelector('[data-sapiato-collection]');

          if (!incomingRoot) {
            this.finish('end');
            return;
          }

          const incomingCards = Array.from(incomingRoot.querySelectorAll('[data-sapiato-product-card]'));
          incomingNextLink = incomingRoot.querySelector('[data-sapiato-next-link]');
          addedCards = incomingCards.map((card) => document.importNode(card, true));

          if (!addedCards.length) {
            nextHref = incomingNextLink ? incomingNextLink.href : '';
          }
        }

        if (!addedCards.length) {
          this.finish('end');
          return;
        }

        addedCards.forEach((card) => {
          this.grid.appendChild(card);
        });
        this.bindProductCarousels();
        this.bindQuickAdd();

        if (this.impressionObserver) {
          this.productCards.forEach((card) => {
            if (card.dataset.sapiatoImpressionSent !== 'true') {
              this.impressionObserver.observe(card);
            }
          });
        }

        await this.waitForPrimaryImages(addedCards);

        if (incomingNextLink) {
          link.href = incomingNextLink.href;
          this.setStatus('');
          shouldCheckForContinuation = true;
        } else {
          this.finish('end');
        }
      } catch (error) {
        this.setStatus('error');
      } finally {
        this.loading = false;
        if (shouldCheckForContinuation) {
          this.queueAutoLoadIfNeeded();
        }
      }
    }

    waitForPrimaryImages(cards) {
      const images = cards
        .map((card) => card.querySelector('.sapiato-product-card__slide:first-child img'))
        .filter(Boolean)
        .slice(0, 8);

      if (!images.length) {
        return Promise.resolve();
      }

      const waitForImage = (image) => {
        if (image.complete) {
          if (image.decode) {
            return image.decode().catch(() => {});
          }

          return Promise.resolve();
        }

        return new Promise((resolve) => {
          const resolveAfterDecode = () => {
            if (image.decode) {
              image.decode().catch(() => {}).then(resolve);
              return;
            }

            resolve();
          };

          image.addEventListener('load', resolveAfterDecode, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      };

      return Promise.race([
        Promise.all(images.map((image) => waitForImage(image))),
        new Promise((resolve) => window.setTimeout(resolve, 1800))
      ]);
    }

    finish(reason) {
      if (this.observer) {
        this.observer.disconnect();
      }

      const controls = this.root.querySelector('[data-sapiato-controls]');
      if (controls) {
        controls.remove();
      }

      this.setStatus(reason);
    }

    setStatus(state) {
      if (!this.status) {
        return;
      }

      if (state === 'loading') {
        this.status.dataset.state = 'loading';
        if (this.statusText) {
          this.statusText.textContent = this.status.dataset.loadingText || 'Loading';
        }
      } else if (state === 'error') {
        this.status.dataset.state = 'error';
        if (this.statusText) {
          this.statusText.textContent = this.status.dataset.errorText || 'Could not load more products';
        }
      } else {
        delete this.status.dataset.state;
        if (this.statusText) {
          this.statusText.textContent = '';
        }
      }
    }
  }

  function initSapiatoCollections(container = document) {
    container.querySelectorAll('[data-sapiato-collection]').forEach((root) => {
      if (root.dataset.sapiatoEnhanced === 'true') {
        return;
      }

      root.dataset.sapiatoEnhanced = 'true';
      new SapiatoCollectionLoader(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSapiatoCollections());
  document.addEventListener('shopify:section:load', (event) => initSapiatoCollections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  class SapiatoCollectionLoader {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-sapiato-product-grid]');
      this.status = root.querySelector('[data-sapiato-status]');
      this.statusText = root.querySelector('[data-sapiato-status-text]');
      this.sentinel = root.querySelector('[data-sapiato-sentinel]');
      this.autoScroll = root.dataset.autoScroll === 'true';
      this.loading = false;
      this.observer = null;

      root.classList.add('is-enhanced');
      this.bindViewControls();
      this.bindProductCarousels();
      this.bindQuickAdd();
      this.bindImpressions();
      this.playInitialCarouselHint();

      if (this.autoScroll) {
        this.bindAutoScroll();
      }
    }

    get nextLink() {
      return this.root.querySelector('[data-sapiato-next-link]');
    }

    get productCards() {
      return Array.from(this.grid.querySelectorAll('[data-sapiato-product-card]'));
    }

    bindViewControls() {
      this.root.querySelectorAll('[data-sapiato-view]').forEach((button) => {
        button.addEventListener('click', () => {
          this.root.dataset.view = button.dataset.sapiatoView;
          this.root.querySelectorAll('[data-sapiato-view]').forEach((viewButton) => {
            viewButton.setAttribute('aria-pressed', String(viewButton === button));
          });
        });
      });

      this.root.querySelectorAll('[data-sapiato-mobile-view]').forEach((button) => {
        button.addEventListener('click', () => {
          this.root.dataset.mobileView = button.dataset.sapiatoMobileView;
          this.root.querySelectorAll('[data-sapiato-mobile-view]').forEach((viewButton) => {
            viewButton.setAttribute('aria-pressed', String(viewButton === button));
          });
        });
      });
    }

    bindProductCarousels() {
      this.root.querySelectorAll('[data-sapiato-product-carousel]').forEach((carousel) => {
        if (carousel.dataset.sapiatoCarouselEnhanced === 'true') {
          return;
        }

        carousel.dataset.sapiatoCarouselEnhanced = 'true';
        let startX = 0;
        let startY = 0;
        let tracking = false;
        let moved = false;

        const reset = () => {
          startX = 0;
          startY = 0;
          tracking = false;
          moved = false;
        };

        carousel.addEventListener('pointerdown', (event) => {
          carousel.dataset.sapiatoUserInteracted = 'true';

          if (event.pointerType === 'mouse') {
            return;
          }

          startX = event.clientX;
          startY = event.clientY;
          tracking = true;
          moved = false;
        }, { passive: true });

        carousel.addEventListener('pointermove', (event) => {
          if (!tracking) {
            return;
          }

          const deltaX = Math.abs(event.clientX - startX);
          const deltaY = Math.abs(event.clientY - startY);
          if (deltaX > 10 && deltaX > deltaY) {
            moved = true;
          }
        }, { passive: true });

        carousel.addEventListener('pointerup', () => {
          if (moved) {
            carousel.dataset.sapiatoSuppressClick = 'true';
            window.setTimeout(() => {
              delete carousel.dataset.sapiatoSuppressClick;
            }, 400);
          }

          reset();
        }, { passive: true });

        carousel.addEventListener('pointercancel', reset, { passive: true });

        carousel.addEventListener('click', (event) => {
          if (carousel.dataset.sapiatoSuppressClick !== 'true') {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          delete carousel.dataset.sapiatoSuppressClick;
        }, true);
      });
    }

    bindQuickAdd() {
      this.root.querySelectorAll('[data-sapiato-quick-add]').forEach((form) => {
        if (form.dataset.sapiatoQuickAddEnhanced === 'true') {
          return;
        }

        form.dataset.sapiatoQuickAddEnhanced = 'true';

        const select = form.querySelector('[data-sapiato-variant-select]');
        const submit = form.querySelector('[data-sapiato-quick-add-submit]');
        const toggle = form.querySelector('[data-sapiato-quick-add-toggle]');
        const panel = form.querySelector('[data-sapiato-quick-add-panel]');
        const feedback = form.querySelector('[data-sapiato-quick-add-feedback]');
        const picker = form.querySelector('[data-sapiato-variant-picker]');
        const pickerToggle = form.querySelector('[data-sapiato-variant-picker-toggle]');
        const pickerOptions = form.querySelector('[data-sapiato-variant-picker-options]');
        const pickerLabel = form.querySelector('[data-sapiato-variant-picker-label]');

        const setFeedback = (message) => {
          if (!feedback) {
            return;
          }

          feedback.textContent = message;
        };

        const updateSubmitState = () => {
          if (!select || !submit) {
            return;
          }

          submit.disabled = !select.value;
        };

        const closePicker = () => {
          if (pickerToggle) {
            pickerToggle.setAttribute('aria-expanded', 'false');
          }
          if (pickerOptions) {
            pickerOptions.hidden = true;
          }
        };

        const openPicker = () => {
          if (!pickerToggle || !pickerOptions) {
            return;
          }

          this.root.querySelectorAll('[data-sapiato-variant-picker-options]').forEach((openOptions) => {
            if (openOptions === pickerOptions || openOptions.hidden) {
              return;
            }

            const openPicker = openOptions.closest('[data-sapiato-variant-picker]');
            const openToggle = openPicker ? openPicker.querySelector('[data-sapiato-variant-picker-toggle]') : null;
            openOptions.hidden = true;
            if (openToggle) {
              openToggle.setAttribute('aria-expanded', 'false');
            }
          });

          pickerToggle.setAttribute('aria-expanded', 'true');
          pickerOptions.hidden = false;
        };

        const choosePickerOption = (option) => {
          if (!select || option.getAttribute('aria-disabled') === 'true') {
            return;
          }

          select.value = option.dataset.variantId || '';
          if (pickerLabel) {
            pickerLabel.textContent = option.dataset.optionLabel || option.textContent.trim();
          }
          if (pickerOptions) {
            pickerOptions.querySelectorAll('[data-sapiato-variant-picker-option]').forEach((button) => {
              button.setAttribute('aria-selected', String(button === option));
            });
          }
          updateSubmitState();
          closePicker();
          if (submit) {
            submit.focus({ preventScroll: true });
          }
        };

        const closePanel = () => {
          form.classList.remove('is-open');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          }
          if (panel) {
            panel.hidden = true;
          }
        };

        const openPanel = () => {
          this.root.querySelectorAll('[data-sapiato-quick-add].is-open').forEach((openForm) => {
            if (openForm === form) {
              return;
            }

            const openToggle = openForm.querySelector('[data-sapiato-quick-add-toggle]');
            const openPanel = openForm.querySelector('[data-sapiato-quick-add-panel]');
            openForm.classList.remove('is-open');
            if (openToggle) {
              openToggle.setAttribute('aria-expanded', 'false');
            }
            if (openPanel) {
              openPanel.hidden = true;
            }
          });

          form.classList.add('is-open');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          }
          if (panel) {
            panel.hidden = false;
            const firstSize = panel.querySelector('button:not(:disabled)');
            if (firstSize) {
              firstSize.focus({ preventScroll: true });
            }
          }
        };

        if (select) {
          updateSubmitState();
          select.addEventListener('change', updateSubmitState);
        }

        if (pickerToggle && pickerOptions) {
          pickerToggle.addEventListener('click', () => {
            if (pickerOptions.hidden) {
              openPicker();
            } else {
              closePicker();
            }
          });

          pickerOptions.querySelectorAll('[data-sapiato-variant-picker-option]').forEach((option) => {
            option.addEventListener('click', () => choosePickerOption(option));
          });

          document.addEventListener('click', (event) => {
            if (!picker || picker.contains(event.target)) {
              return;
            }

            closePicker();
          }, { passive: true });
        }

        if (toggle && panel) {
          toggle.addEventListener('click', () => {
            if (form.classList.contains('is-open')) {
              closePanel();
            } else {
              openPanel();
            }
          });

          document.addEventListener('click', (event) => {
            if (!form.classList.contains('is-open') || form.contains(event.target)) {
              return;
            }

            closePanel();
          }, { passive: true });
        }

        form.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closePanel();
            closePicker();
          }
        });

        form.addEventListener('focusout', (event) => {
          if (!picker || !pickerOptions || pickerOptions.hidden || picker.contains(event.relatedTarget)) {
            return;
          }

          closePicker();
        });

        form.addEventListener('focusout', (event) => {
          if (!panel || !form.classList.contains('is-open') || form.contains(event.relatedTarget)) {
            return;
          }

          closePanel();
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          const submitter = event.submitter;
          const formData = new FormData(form);
          const variantId = submitter && submitter.name === 'id' ? submitter.value : formData.get('id');

          if (!variantId) {
            setFeedback(form.dataset.chooseSizeError || '');
            if (pickerToggle) {
              pickerToggle.focus();
            } else if (select) {
              select.focus();
            }
            return;
          }

          const quantity = Number(formData.get('quantity') || 1);
          const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
          const labelButton = submitter && submitter.matches('[data-sapiato-quick-add-submit]') ? submitter : null;
          const originalLabel = labelButton ? labelButton.textContent : '';

          buttons.forEach((button) => {
            button.dataset.sapiatoWasDisabled = String(button.disabled);
            button.disabled = true;
          });

          if (select) {
            select.disabled = true;
          }

          if (labelButton) {
            labelButton.textContent = form.dataset.addingText || originalLabel;
          }
          setFeedback(form.dataset.addingText || '');

          try {
            const response = await fetch(form.dataset.sapiatoCartAddUrl || `${form.action}.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: variantId,
                quantity
              })
            });

            if (!response.ok) {
              throw new Error(form.dataset.errorText || '');
            }

            const item = await response.json();
            if (labelButton) {
              labelButton.textContent = form.dataset.addedText || originalLabel;
            }
            setFeedback(form.dataset.addedText || '');

            window.dispatchEvent(new CustomEvent('sapiato:quick-add', {
              detail: {
                item,
                productId: form.dataset.productId,
                variantId
              }
            }));

            window.setTimeout(() => {
              closePanel();
              closePicker();
              setFeedback('');
              if (labelButton) {
                labelButton.textContent = originalLabel;
              }
            }, 1200);
          } catch (error) {
            if (labelButton) {
              labelButton.textContent = originalLabel;
            }
            setFeedback(form.dataset.errorText || '');
          } finally {
            buttons.forEach((button) => {
              button.disabled = button.dataset.sapiatoWasDisabled === 'true';
              delete button.dataset.sapiatoWasDisabled;
            });

            if (select) {
              select.disabled = false;
            }

            updateSubmitState();
          }
        });
      });
    }

    playInitialCarouselHint() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const carousel = this.grid.querySelector('[data-sapiato-product-carousel]');
      if (!carousel || carousel.dataset.sapiatoHintPlayed === 'true') {
        return;
      }

      const slides = carousel.querySelectorAll('.sapiato-product-card__slide');
      if (slides.length < 2) {
        return;
      }

      carousel.dataset.sapiatoHintPlayed = 'true';

      const runHint = () => {
        if (!this.root.isConnected || carousel.dataset.sapiatoUserInteracted === 'true') {
          return;
        }

        const carouselWidth = carousel.clientWidth;
        if (!carouselWidth || carousel.scrollWidth <= carouselWidth) {
          return;
        }

        const hintDistance = Math.max(56, Math.min(carouselWidth * 0.36, 170));
        carousel.classList.add('is-swipe-hinting');
        carousel.scrollTo({ left: hintDistance, behavior: 'smooth' });

        window.setTimeout(() => {
          if (!this.root.isConnected || carousel.dataset.sapiatoUserInteracted === 'true') {
            return;
          }

          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        }, 520);

        window.setTimeout(() => {
          carousel.classList.remove('is-swipe-hinting');
        }, 1120);
      };

      const firstImage = carousel.querySelector('img');
      if (firstImage && !firstImage.complete) {
        firstImage.addEventListener('load', () => window.setTimeout(runHint, 420), { once: true });
        firstImage.addEventListener('error', () => window.setTimeout(runHint, 420), { once: true });
        return;
      }

      window.setTimeout(runHint, 620);
    }

    bindAutoScroll() {
      if (!this.sentinel || !this.nextLink) {
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadNextPage();
          }
        });
      }, { rootMargin: '700px 0px' });

      this.observer.observe(this.sentinel);
    }

    shouldAutoLoadAgain() {
      if (!this.autoScroll || !this.sentinel || !this.nextLink) {
        return false;
      }

      const rect = this.sentinel.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top <= viewportHeight + 700;
    }

    queueAutoLoadIfNeeded() {
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          if (!this.loading && this.shouldAutoLoadAgain()) {
            this.loadNextPage();
          }
        }, 80);
      });
    }

    bindImpressions() {
      if (!('IntersectionObserver' in window)) {
        return;
      }

      const impressionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const card = entry.target;
          if (card.dataset.sapiatoImpressionSent === 'true') {
            return;
          }

          card.dataset.sapiatoImpressionSent = 'true';
          window.dispatchEvent(new CustomEvent('sapiato:collection-product-impression', {
            detail: {
              productId: card.dataset.productId,
              productHandle: card.dataset.productHandle,
              collectionHandle: this.root.dataset.collectionHandle
            }
          }));
          impressionObserver.unobserve(card);
        });
      }, { threshold: 0.45 });

      this.productCards.forEach((card) => impressionObserver.observe(card));
      this.impressionObserver = impressionObserver;
    }

    async loadNextPage() {
      const link = this.nextLink;
      if (!link || this.loading) {
        return;
      }

      this.loading = true;
      this.setStatus('loading');
      let shouldCheckForContinuation = false;

      try {
        const visitedUrls = new Set();
        let nextHref = link.href;
        let incomingNextLink = null;
        let addedCards = [];

        while (nextHref && !addedCards.length && !visitedUrls.has(nextHref)) {
          visitedUrls.add(nextHref);
          const response = await fetch(nextHref, { credentials: 'same-origin' });
          if (!response.ok) {
            throw new Error('Could not load collection page');
          }

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const incomingRoot = documentFragment.querySelector('[data-sapiato-collection]');

          if (!incomingRoot) {
            this.finish('end');
            return;
          }

          const incomingCards = Array.from(incomingRoot.querySelectorAll('[data-sapiato-product-card]'));
          incomingNextLink = incomingRoot.querySelector('[data-sapiato-next-link]');
          addedCards = incomingCards.map((card) => document.importNode(card, true));

          if (!addedCards.length) {
            nextHref = incomingNextLink ? incomingNextLink.href : '';
          }
        }

        if (!addedCards.length) {
          this.finish('end');
          return;
        }

        addedCards.forEach((card) => {
          this.grid.appendChild(card);
        });
        this.bindProductCarousels();
        this.bindQuickAdd();

        if (this.impressionObserver) {
          this.productCards.forEach((card) => {
            if (card.dataset.sapiatoImpressionSent !== 'true') {
              this.impressionObserver.observe(card);
            }
          });
        }

        await this.waitForPrimaryImages(addedCards);

        if (incomingNextLink) {
          link.href = incomingNextLink.href;
          this.setStatus('');
          shouldCheckForContinuation = true;
        } else {
          this.finish('end');
        }
      } catch (error) {
        this.setStatus('error');
      } finally {
        this.loading = false;
        if (shouldCheckForContinuation) {
          this.queueAutoLoadIfNeeded();
        }
      }
    }

    waitForPrimaryImages(cards) {
      const images = cards
        .map((card) => card.querySelector('.sapiato-product-card__slide:first-child img'))
        .filter(Boolean)
        .slice(0, 8);

      if (!images.length) {
        return Promise.resolve();
      }

      const waitForImage = (image) => {
        if (image.complete) {
          if (image.decode) {
            return image.decode().catch(() => {});
          }

          return Promise.resolve();
        }

        return new Promise((resolve) => {
          const resolveAfterDecode = () => {
            if (image.decode) {
              image.decode().catch(() => {}).then(resolve);
              return;
            }

            resolve();
          };

          image.addEventListener('load', resolveAfterDecode, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      };

      return Promise.race([
        Promise.all(images.map((image) => waitForImage(image))),
        new Promise((resolve) => window.setTimeout(resolve, 1800))
      ]);
    }

    finish(reason) {
      if (this.observer) {
        this.observer.disconnect();
      }

      const controls = this.root.querySelector('[data-sapiato-controls]');
      if (controls) {
        controls.remove();
      }

      this.setStatus(reason);
    }

    setStatus(state) {
      if (!this.status) {
        return;
      }

      if (state === 'loading') {
        this.status.dataset.state = 'loading';
        if (this.statusText) {
          this.statusText.textContent = this.status.dataset.loadingText || 'Loading';
        }
      } else if (state === 'error') {
        this.status.dataset.state = 'error';
        if (this.statusText) {
          this.statusText.textContent = this.status.dataset.errorText || 'Could not load more products';
        }
      } else {
        delete this.status.dataset.state;
        if (this.statusText) {
          this.statusText.textContent = '';
        }
      }
    }
  }

  function initSapiatoCollections(container = document) {
    container.querySelectorAll('[data-sapiato-collection]').forEach((root) => {
      if (root.dataset.sapiatoEnhanced === 'true') {
        return;
      }

      root.dataset.sapiatoEnhanced = 'true';
      new SapiatoCollectionLoader(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSapiatoCollections());
  document.addEventListener('shopify:section:load', (event) => initSapiatoCollections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  class SapiatoSearchGrid {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-sapiato-product-grid]');
      this.status = root.querySelector('[data-sapiato-status]');
      this.statusText = root.querySelector('[data-sapiato-status-text]');
      this.sentinel = root.querySelector('[data-sapiato-sentinel]');
      this.autoScroll = root.dataset.autoScroll === 'true';
      this.loading = false;
      this.observer = null;

      this.bindViewControls();
      this.bindQuickAddPanels();
      this.bindCarouselClickGuard();

      if (this.autoScroll) {
        this.bindAutoScroll();
      }
    }

    get nextLink() {
      return this.root.querySelector('[data-sapiato-next-link]');
    }

    bindViewControls() {
      this.root.querySelectorAll('[data-sapiato-view]').forEach((button) => {
        button.addEventListener('click', () => {
          this.root.dataset.view = button.dataset.sapiatoView;
          this.root.querySelectorAll('[data-sapiato-view]').forEach((viewButton) => {
            viewButton.setAttribute('aria-pressed', String(viewButton === button));
          });
        });
      });

      this.root.querySelectorAll('[data-sapiato-mobile-view]').forEach((button) => {
        button.addEventListener('click', () => {
          this.root.dataset.mobileView = button.dataset.sapiatoMobileView;
          this.root.querySelectorAll('[data-sapiato-mobile-view]').forEach((viewButton) => {
            viewButton.setAttribute('aria-pressed', String(viewButton === button));
          });
        });
      });
    }

    bindQuickAddPanels() {
      this.root.querySelectorAll('[data-sapiato-quick-add]').forEach((form) => {
        if (form.dataset.sapiatoQuickAddPanelEnhanced === 'true') {
          return;
        }

        form.dataset.sapiatoQuickAddPanelEnhanced = 'true';

        const toggle = form.querySelector('[data-sapiato-quick-add-toggle]');
        const panel = form.querySelector('[data-sapiato-quick-add-panel]');
        const select = form.querySelector('[data-sapiato-variant-select]');
        const submit = form.querySelector('[data-sapiato-quick-add-submit]');
        const feedback = form.querySelector('[data-sapiato-quick-add-feedback]');
        const picker = form.querySelector('[data-sapiato-variant-picker]');
        const pickerToggle = form.querySelector('[data-sapiato-variant-picker-toggle]');
        const pickerOptions = form.querySelector('[data-sapiato-variant-picker-options]');
        const pickerLabel = form.querySelector('[data-sapiato-variant-picker-label]');

        const updateSubmitState = () => {
          if (!select || !submit) {
            return;
          }

          submit.disabled = !select.value;
        };

        const closePicker = () => {
          if (pickerToggle) {
            pickerToggle.setAttribute('aria-expanded', 'false');
          }
          if (pickerOptions) {
            pickerOptions.hidden = true;
          }
        };

        const openPicker = () => {
          if (!pickerToggle || !pickerOptions) {
            return;
          }

          this.root.querySelectorAll('[data-sapiato-variant-picker-options]').forEach((openOptions) => {
            if (openOptions === pickerOptions || openOptions.hidden) {
              return;
            }

            const openPicker = openOptions.closest('[data-sapiato-variant-picker]');
            const openToggle = openPicker ? openPicker.querySelector('[data-sapiato-variant-picker-toggle]') : null;
            openOptions.hidden = true;
            if (openToggle) {
              openToggle.setAttribute('aria-expanded', 'false');
            }
          });

          pickerToggle.setAttribute('aria-expanded', 'true');
          pickerOptions.hidden = false;
        };

        const choosePickerOption = (option) => {
          if (!select || option.getAttribute('aria-disabled') === 'true') {
            return;
          }

          select.value = option.dataset.variantId || '';
          if (pickerLabel) {
            pickerLabel.textContent = option.dataset.optionLabel || option.textContent.trim();
          }
          if (pickerOptions) {
            pickerOptions.querySelectorAll('[data-sapiato-variant-picker-option]').forEach((button) => {
              button.setAttribute('aria-selected', String(button === option));
            });
          }
          updateSubmitState();
          closePicker();
          if (submit) {
            submit.focus({ preventScroll: true });
          }
        };

        if (select) {
          updateSubmitState();
          select.addEventListener('change', updateSubmitState);
        }

        if (pickerToggle && pickerOptions) {
          pickerToggle.addEventListener('click', () => {
            if (pickerOptions.hidden) {
              openPicker();
            } else {
              closePicker();
            }
          });

          pickerOptions.querySelectorAll('[data-sapiato-variant-picker-option]').forEach((option) => {
            option.addEventListener('click', () => choosePickerOption(option));
          });

          document.addEventListener('click', (event) => {
            if (!picker || picker.contains(event.target)) {
              return;
            }

            closePicker();
          }, { passive: true });
        }

        form.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closePicker();
          }
        });

        form.addEventListener('focusout', (event) => {
          if (!picker || !pickerOptions || pickerOptions.hidden || picker.contains(event.relatedTarget)) {
            return;
          }

          closePicker();
        });

        form.addEventListener('submit', (event) => {
          if (!select || select.value) {
            return;
          }

          event.preventDefault();
          if (feedback) {
            feedback.textContent = form.dataset.chooseSizeError || '';
          }
          if (pickerToggle) {
            pickerToggle.focus();
          }
        });

        if (!toggle || !panel) {
          return;
        }

        toggle.addEventListener('click', () => {
          const isOpen = form.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
          panel.hidden = !isOpen;
          closePicker();
        });
      });
    }

    bindCarouselClickGuard() {
      this.root.querySelectorAll('[data-sapiato-product-carousel]').forEach((carousel) => {
        if (carousel.dataset.sapiatoCarouselEnhanced === 'true') {
          return;
        }

        carousel.dataset.sapiatoCarouselEnhanced = 'true';

        let startX = 0;
        let startY = 0;
        let tracking = false;
        let moved = false;

        carousel.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') {
            return;
          }
          startX = event.clientX;
          startY = event.clientY;
          tracking = true;
          moved = false;
        }, { passive: true });

        carousel.addEventListener('pointermove', (event) => {
          if (!tracking) {
            return;
          }
          const deltaX = Math.abs(event.clientX - startX);
          const deltaY = Math.abs(event.clientY - startY);
          if (deltaX > 10 && deltaX > deltaY) {
            moved = true;
          }
        }, { passive: true });

        carousel.addEventListener('pointerup', () => {
          if (moved) {
            carousel.dataset.sapiatoSuppressClick = 'true';
            window.setTimeout(() => {
              delete carousel.dataset.sapiatoSuppressClick;
            }, 400);
          }
          tracking = false;
        }, { passive: true });

        carousel.addEventListener('click', (event) => {
          if (carousel.dataset.sapiatoSuppressClick !== 'true') {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          delete carousel.dataset.sapiatoSuppressClick;
        }, true);
      });
    }

    bindAutoScroll() {
      if (!('IntersectionObserver' in window) || !this.sentinel || !this.nextLink) {
        return;
      }

      this.root.classList.add('is-enhanced');

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadNextPage();
          }
        });
      }, { rootMargin: '700px 0px' });

      this.observer.observe(this.sentinel);
    }

    shouldAutoLoadAgain() {
      if (!this.autoScroll || !this.sentinel || !this.nextLink) {
        return false;
      }

      const rect = this.sentinel.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top <= viewportHeight + 700;
    }

    queueAutoLoadIfNeeded() {
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          if (!this.loading && this.shouldAutoLoadAgain()) {
            this.loadNextPage();
          }
        }, 80);
      });
    }

    async loadNextPage() {
      const link = this.nextLink;
      if (!link || this.loading) {
        return;
      }

      this.loading = true;
      this.setStatus('loading');
      let shouldCheckForContinuation = false;

      try {
        const visitedUrls = new Set();
        let nextHref = link.href;
        let incomingNextLink = null;
        let addedCards = [];

        while (nextHref && !addedCards.length && !visitedUrls.has(nextHref)) {
          visitedUrls.add(nextHref);
          const response = await fetch(nextHref, { credentials: 'same-origin' });
          if (!response.ok) {
            throw new Error('Could not load search page');
          }

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const incomingRoot = documentFragment.querySelector('[data-sapiato-search]');

          if (!incomingRoot) {
            this.finish('end');
            return;
          }

          const incomingCards = Array.from(incomingRoot.querySelectorAll('[data-sapiato-product-card]'));
          incomingNextLink = incomingRoot.querySelector('[data-sapiato-next-link]');
          addedCards = incomingCards.map((card) => document.importNode(card, true));

          if (!addedCards.length) {
            nextHref = incomingNextLink ? incomingNextLink.href : '';
          }
        }

        if (!addedCards.length) {
          this.finish('end');
          return;
        }

        addedCards.forEach((card) => {
          this.grid.appendChild(card);
        });

        this.bindQuickAddPanels();
        this.bindCarouselClickGuard();

        await this.waitForPrimaryImages(addedCards);

        if (incomingNextLink) {
          link.href = incomingNextLink.href;
          this.setStatus('');
          shouldCheckForContinuation = true;
        } else {
          this.finish('end');
        }
      } catch (error) {
        this.setStatus('error');
      } finally {
        this.loading = false;
        if (shouldCheckForContinuation) {
          this.queueAutoLoadIfNeeded();
        }
      }
    }

    waitForPrimaryImages(cards) {
      const images = cards
        .map((card) => card.querySelector('.sapiato-product-card__slide:first-child img'))
        .filter(Boolean)
        .slice(0, 8);

      if (!images.length) {
        return Promise.resolve();
      }

      const waitForImage = (image) => {
        if (image.complete) {
          if (image.decode) {
            return image.decode().catch(() => {});
          }

          return Promise.resolve();
        }

        return new Promise((resolve) => {
          const resolveAfterDecode = () => {
            if (image.decode) {
              image.decode().catch(() => {}).then(resolve);
              return;
            }

            resolve();
          };

          image.addEventListener('load', resolveAfterDecode, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      };

      return Promise.race([
        Promise.all(images.map((image) => waitForImage(image))),
        new Promise((resolve) => window.setTimeout(resolve, 1800))
      ]);
    }

    finish(reason) {
      if (this.observer) {
        this.observer.disconnect();
      }

      const controls = this.root.querySelector('[data-sapiato-controls]');
      if (controls) {
        controls.remove();
      }

      this.setStatus(reason);
    }

    setStatus(state) {
      if (!this.status) {
        return;
      }

      if (state === 'loading') {
        this.status.dataset.state = 'loading';
        if (this.statusText) {
          this.statusText.textContent = this.status.dataset.loadingText || 'Loading';
        }
      } else if (state === 'error') {
        this.status.dataset.state = 'error';
        if (this.statusText) {
          this.statusText.textContent = this.status.dataset.errorText || 'Could not load more products';
        }
      } else {
        delete this.status.dataset.state;
        if (this.statusText) {
          this.statusText.textContent = '';
        }
      }
    }
  }

  function initSapiatoSearch(container = document) {
    container.querySelectorAll('[data-sapiato-search]').forEach((root) => {
      if (root.dataset.sapiatoSearchEnhanced === 'true') {
        return;
      }
      root.dataset.sapiatoSearchEnhanced = 'true';
      new SapiatoSearchGrid(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSapiatoSearch());
  document.addEventListener('shopify:section:load', (event) => initSapiatoSearch(event.target));

  } catch(e) { console.error(e); }
})();
})();
